import { actionGenerator, IReduxAction } from '../../utils/actions';
import { IOfferState } from '../../types/reducers/offer';

export const SET_OFFER = 'OFFER :: SET_OFFER';

export type TSetOfferPayload = IReduxAction<typeof SET_OFFER, Partial<IOfferState>>;

export const setOffer = actionGenerator<typeof SET_OFFER, Partial<IOfferState>>(SET_OFFER);
